<app-form-select
  [(ngModel)]="booleanValue"
  (ngModelChange)="setChange()"
  [type]="'boolean'"
  [label]="label"
  [placeholder]="placeholder"
  [translateKey]="translateKey"
  [options]="options"></app-form-select>

